module.exports = __webpack_public_path__ + "0a603abe9b66e8ff08f677184b18a8cd.svg";